<template>
  <div class="auth-form__form-wrapper">
    <form
      @submit.prevent="validateFields"
      class="ine-form__form auth-form__form"
    >
      <Title
        class="auth-form__title-wrapper auth-form__title-wrapper--compressed"
        header="Enter your 6-digit MFA code"
        tagline="SMS, email, or Google Authenticator"
      />
      <DigitCodeInput :isGoogleAuthenticatorMFA="isGoogleAuthenticatorMFA" />
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import DigitCodeInput from '@/components/shared/DigitCodeInput.vue'

export default {
  name: 'TwoFactorForm',
  components: {
    Title,
    DigitCodeInput,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isGoogleAuthenticatorMFA: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        'mfa code': {
          type: 'text',
          rules: ['presence'],
          placeholder: 'MFA Code',
          value: '',
          autocomplete: 'one-time-code',
        },
      },
    }
  },
  methods: {
    validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          code: fields['mfa code'].value,
        }
        this.$emit('submit-form', payload)
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
}
</script>
